import { render, staticRenderFns } from "./contact_phone.vue?vue&type=template&id=09e4702e"
import script from "./contact_phone.vue?vue&type=script&lang=js"
export * from "./contact_phone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports